module.exports = "<app-tour [temp]=\"temp\"></app-tour>\r\n"